import moment from "moment";

const initProgramList = () => {
    const programContainers = document.querySelectorAll(".js-schedule-list .show__container");
    const programItems = document.querySelectorAll(".js-schedule-list .show");
    const programItemActiveClass = "show_active";
    const carouselItemActiveClass = "carousel__item--active";
    const originUrlSearch = window.location.search;
    const programContainerViewedClass = "show__container_viewed";

    if (programContainers.length) {

        const pathNameDate = window.location.pathname.replace("/program/", "");
        let scrollTarget;
        if (moment(pathNameDate).isValid()) {
            scrollTarget = document.querySelector(`.js-schedule-list [data-date="${pathNameDate}"]`);
            if (scrollTarget) {
                scrollTarget.scrollIntoView({ behavior: "instant" });
            }
        }
    
        programContainers.forEach((programContainer) => {
            const date = programContainer.dataset.date;
            let observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        const { isIntersecting } = entry;
                        if (isIntersecting) {
                            window.history.pushState("", "", `/program/${date}${originUrlSearch}`);
                            document.title = `Телепрограмма на ${moment(date).locale('ru').format('dd')}, ${moment(date).locale('ru').format('D MMMM')}`;

                            const carousel = document.querySelector(".carousel--schedule .carousel__container")?.swiper;
                            const newSlide = carousel.slides.find((slide) => slide.dataset.date === date);
                            if (newSlide) {
                                const newSlideIndex = carousel.slides.indexOf(newSlide);
                                document
                                    .querySelector(".js-schedule-date-slide.carousel__item--active")
                                    .classList.remove(carouselItemActiveClass);
                                newSlide.classList.add(carouselItemActiveClass);
                                carousel.slideTo(newSlideIndex);
                            }
                            if (!programContainer.classList.contains(programContainerViewedClass)) {
                                // console.log("ads init");
                                programContainer.classList.add(programContainerViewedClass);
                            } else {
                                console.log("ads reload");
                                Ya.adfoxCode.reload(`desktop_middle_${date}`, {onlyIfWasVisible: true});
                            }
                            console.log("ads aside reload");
                            Ya.adfoxCode.reload("vertical_1", {onlyIfWasVisible: true});
                        }
                    });
                },
                {
                    rootMargin: "-50% 0% -50% 0%",
                    threshold: 0,
                }
            );
            observer.observe(programContainer);
        });
        programItems.forEach((programItem) => {
            programItem.addEventListener("click", () => {
                programItem.classList.toggle(programItemActiveClass);
            });
        });
    
        // Sticky
        const supportPageOffset = window.scrollX !== undefined;
        const isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    
        const $carousel = document.querySelector(".schedule-detail__carousel");
        if ($carousel) {
            const $parent = $carousel.parentNode;
            const carouselStickyClass = "schedule-detail__carousel_sticky";
            function carouselSticky() {
                const scrolledYPosition = supportPageOffset
                    ? window.scrollY
                    : isCSS1Compat
                        ? document.documentElement.scrollTop
                        : document.body.scrollTop;
                if (scrolledYPosition > $parent.offsetTop) {
                    $carousel.classList.add(carouselStickyClass);
                } else {
                    $carousel.classList.remove(carouselStickyClass);
                }
            }
            window.addEventListener("scroll", carouselSticky);
        }
    }

    function sticky(element) {
        const $parent = element.parentNode;
        const parentRect = $parent.getBoundingClientRect();
        const innerOffset = $parent.offsetHeight - element.offsetHeight;
        if (parentRect.top < 0) {
            element.style.position = "fixed";
            element.style.left = `${parentRect.left}px`;
            if (parentRect.top * -1 < innerOffset) {
                element.style.top = 0;
            } else {
                element.style.top = `${parentRect.top + innerOffset}px`;
            }
            element.style.width = `${$parent.offsetWidth}px`;
        } else {
            element.style.position = "static";
            element.style.left = 0;
            element.style.top = 0;
            element.style.width = "auto";
        }

    }
    const $ads = document.querySelector(".container__aside .ads");

    if ($ads) {
        window.addEventListener("scroll", () => sticky($ads));
        window.addEventListener("resize", () => sticky($ads));
    }
};

export default initProgramList;
